import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { VehicleHistoryReportSettingsModel } from './models/vehicle.history.report-settings';

@Component({
  selector   : 'wor-vehicle-history-report',
  template: require('./vehicle.history.report.component.html')
})
export class VehicleHistoryReportComponent {
  settings : VehicleHistoryReportSettingsModel = {
    printTotal : false,
    showSummary: false
  };

  constructor ( public activeModal: NgbActiveModal ) {}

  confirm () : void {


    this.activeModal.close(this.settings);


    };


  }
